/* global globals */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Accordion, AccordionItem } from 'react-sanfona';

import PrintDate from '../../components/misc';

class LogViewContainer extends Component {
  state = {
    logs: null,
  };

  fetchData = this.fetchData.bind(this);

  componentDidMount() {
    this.fetchData();
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { memberId } = this.props;
    if (nextProps.memberId !== memberId) {
      this.fetchData();
    }
  }

  fetchData() {
    const { memberId } = this.props;
    if (memberId.length < 1) {
      return;
    }
    const headers = {
      credentials: 'same-origin',
    };
    fetch(`${get(globals, 'apiWebroot', '/')}member/get_logs/${memberId}`, headers)
      .then((resp) => resp.json())
      .then((data) => {
        this.setState({ logs: data });
      })
      .catch(() => {
        // console.log('fetch failed: ', error);
      });
  }

  render() {
    let json;
    const { logs } = this.state;
    const { memberId } = this.props;

    if (logs) {
      json = logs;
    } else {
      json = `couldn't get member ${memberId} logs`;
    }

    const actionItems = () => {
      const items = [];

      if (typeof json !== 'object') {
        return (json);
      }

      if (json.length === 0) {
        return (`couldn't get member ${memberId} logs`);
      }

      Object.keys(json).forEach((k) => {
        let title = '';
        let time = '';
        const otherData = [];

        if (typeof json[k].action !== 'undefined') {
          title = json[k].action;
        }

        if (typeof json[k].time !== 'undefined') {
          time = json[k].time.$date.$numberLong;
        }

        if (typeof json[k].member !== 'undefined') {
          otherData.push(<div><b>member info:</b></div>);
          Object.keys(json[k].member).forEach((key) => {
            otherData.push(<div className="plm">{`${key}: ${json[k].member[key]}`}</div>);
          });
        }

        if (typeof json[k].otherData !== 'undefined') {
          otherData.push(<div><b>other data:</b></div>);
          Object.keys(json[k]).forEach((key) => {
            otherData.push(<div className="plm">{`${key}: ${json[k].otherData[key]}`}</div>);
          });
        }

        items.push((
          <AccordionItem title={title} expanded>
            <PrintDate time={time} format="D.m.Y" />
            {otherData}
          </AccordionItem>
        ));
      });

      return (
        <Accordion allowMultiple>
          {items}
        </Accordion>
      );
    };

    return (
      actionItems()
    );
  }
}

LogViewContainer.propTypes = {
  memberId: PropTypes.string.isRequired,
};

export default LogViewContainer;
